<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nuevo expediente</v-toolbar-title>
    </v-toolbar>
    <v-card class="spacing-top" v-if="loading">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-card>
    <v-card class="spacing-top px-2 custom-font-regular" v-else>
      <v-card-text>
        <div class="title-form mt-3">Cabecera de expediente</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2">
          <v-layout row wrap>
            <v-flex xs6 pr-2>
              <v-text-field v-model="code" :error-messages="codeErrors" label="Número de expediente" required
                @input="$v.code.$touch()" prepend-icon="fa-barcode"></v-text-field>
            </v-flex>
            <v-flex xs6 pl-2>
              <v-autocomplete v-model="tipo" :items="tipos" label="Tipo de expediente" itemText="description"
                itemValue="id" prepend-icon="fa-list" light no-data-text="No hay datos disponibles" dense
                :loading="loadingClubs" :error-messages="tipoErrors"></v-autocomplete>
            </v-flex>
            <v-flex xs4 pl-2>
              <v-autocomplete v-model="club" :items="clubs" label="Club" itemText="nombre" itemValue="pk"
                prepend-icon="fa-users" light no-data-text="No hay datos disponibles" dense :error-messages="clubErrors"
                :loading="loadingClubs" @change="cleanAll"></v-autocomplete>
            </v-flex>
            <v-flex xs8 pr-2 pl-2>
              <v-text-field v-model="expedienteDescription" label="Título del expediente" required
                :error-messages="descriptionErrors" @input="$v.expedienteDescription.$touch()"
                prepend-icon="fa-comment"></v-text-field>
            </v-flex>
            <div style="width: 100%;"></div>
            <v-checkbox v-model="isMatch" :disabled="club === null" @change="fetchTorneos"
              label="Asociar un partido"></v-checkbox>
            <div style="width: 100%;"></div>
            <v-icon v-if="isMatch" class="mr-3">fa-trophy</v-icon>
            <v-flex v-if="isMatch" xs3 pr-2>
              <v-select v-model="torneo" :items="torneos" item-text="description" item-value="id"
                :error-messages="torneoErrors" label="Torneo" @change="fetchFechas"
                no-data-text="No hay datos disponibles"></v-select>
            </v-flex>
            <v-icon v-if="isMatch" class="ml-3 mr-2">fa-calendar</v-icon>
            <v-flex v-if="isMatch" xs3 px-2>
              <v-select v-model="fecha" :items="fechas" item-text="nombreCompleto" item-value="id"
                :error-messages="fechaErrors" label="Fecha" @change="fetchPartidos"
                no-data-text="No hay datos disponibles"></v-select>
            </v-flex>
            <v-icon v-if="isMatch">fa-futbol</v-icon>
            <v-flex v-if="isMatch" xs4 pl-2>
              <v-select v-model="partido" :items="partidos" item-text="description" item-value="id"
                :error-messages="partidoErrors" label="Partido" @change="fetchInformes"
                no-data-text="No hay datos disponibles"></v-select>
            </v-flex>
            <div style="width: 100%;"></div>
            <v-icon v-if="isMatch">mdi-soccer-field</v-icon>
            <v-flex v-if="isMatch" xs4>
              <v-text-field disabled v-model="stadium" label="Estadio"></v-text-field>
            </v-flex>
            <v-icon v-if="isMatch">mdi-calendar</v-icon>
            <v-flex v-if="isMatch" xs4>
              <v-text-field disabled v-model="dayhour" label="Día y horario del partido"></v-text-field>
            </v-flex>
            <div style="width: 100%;"></div>
            <v-icon v-if="isMatch">fa-file</v-icon>
            <v-flex v-if="isMatch" xs5 pl-1 ml-2>
              <v-select v-model="informe" :items="informes" item-text="reportDescription" item-value="pk"
                :error-messages="informeErrors" label="Informe" @change="retornarAutorInforme"
                no-data-text="No hay datos disponibles"></v-select>
            </v-flex>
            <div v-if="informe && isMatch" style="display: flex;">
              <v-icon class="ml-3 mr-2">fa-user</v-icon>
              <span class="autor-informe">Autor del informe: {{ autorInforme }}</span>
            </div>
          </v-layout>
        </div>
        <v-divider class="mt-5 mb-2"></v-divider>
        <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
          text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
        <v-card-actions>
          <v-btn color="blue-grey-lighten-4" depressed :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="uploadAllFiles" depressed color="primary" :disabled="saving">Enviar</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  mixins: [validationMixin, createEntityMixin, s3UploadMixin],

  validations () {
    return {
      code: { required },
      club: { required },
      tipo: { required },
      expedienteDescription: { required: requiredIf((descriptionModel) => !descriptionModel.isMatch) },
      torneo: { required: requiredIf((torneoModel) => torneoModel.isMatch) },
      fecha: { required: requiredIf((fechaModel) => fechaModel.isMatch) },
      partido: { required: requiredIf((partidoModel) => partidoModel.isMatch) },
      informe: { required: requiredIf((informeModel) => informeModel.isMatch) }
    }
  },

  components: {
    ConfirmationDialog
  },

  data () {
    return {
      loadingClubs: false,
      code: '',
      date: null,
      clubs: [],
      club: null,
      canViewAttachments: false,
      uploadedFiles: [],
      createPath: 'expedientes/create',
      editPath: `case_file/edit/${this.$route.params.idCaseFile}`,
      torneos: [],
      fechas: [],
      partidos: [],
      torneo: null,
      fecha: null,
      partido: null,
      isMatch: false,
      informes: [],
      informe: null,
      expedienteDescription: null,
      stadium: null,
      tipo: null,
      tipos: [],
      dayhour: null,
      autorInforme: null
    }
  },

  computed: {
    codeErrors () {
      return this.getRequiredErrors('code')
    },
    clubErrors () {
      return this.getRequiredErrors('club')
    },
    tipoErrors () {
      return this.getRequiredErrors('tipo')
    },
    descriptionErrors () {
      const errors = []
      if (!this.isMatch && !this.$v.expedienteDescription.$dirty) return errors
      !this.$v.expedienteDescription.required && errors.push('La descripción es requerida.')
      return errors
    },
    torneoErrors () {
      const errors = []
      if (this.isMatch && !this.$v.torneo.$dirty) return errors
      !this.$v.torneo.required && errors.push('El torneo es requerido.')
      return errors
    },
    fechaErrors () {
      const errors = []
      if (this.isMatch && !this.$v.fecha.$dirty) return errors
      !this.$v.fecha.required && errors.push('La fecha es requerida.')
      return errors
    },
    partidoErrors () {
      const errors = []
      if (this.isMatch && !this.$v.partido.$dirty) return errors
      !this.$v.partido.required && errors.push('El partido es requerido.')
      return errors
    },
    informeErrors () {
      const errors = []
      if (this.isMatch && !this.$v.informe.$dirty) return errors
      !this.$v.informe.required && errors.push('El informe es requerido.')
      return errors
    }
  },

  methods: {
    getPayload () {
      let payload = {
        'code': this.code,
        'club': this.club,
        'type': this.tipo,
        'description': this.expedienteDescription,
        'match': this.partido,
        'informe': this.informe,
        'author': this.$store.state.authUser
        /* 'can_view_attachments': this.canViewAttachments,
        'assets': this.assets */
      }
      if (this.match) payload.match = this.match
      if (this.matchDate) payload.match_date = this.matchDate
      if (this.matchStadium) payload.match_stadium = this.matchStadium
      return payload
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    fetchClubs () {
      this.loadingClubs = true
      this.axios
        .get('clubes')
        .then(response => {
          this.clubs = response.data
          this.loadingClubs = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    add (array) {
      array.push('')
    },
    remove (array) {
      array.pop()
    },
    fetchTorneos () {
      this.axios
        .get('informe-auditoria/torneos?active=true')
        .then(response => {
          this.torneos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchFechas () {
      this.partido = null
      this.stadium = null
      this.dayhour = null
      this.partidos = []
      this.informes = []
      this.informe = null
      this.axios
        .get(`informe-auditoria/fechas?torneo=${this.torneo}&order=desc`)
        .then(response => {
          this.fechas = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchPartidos () {
      this.stadium = null
      this.dayhour = null
      this.informes = []
      this.informe = null
      this.axios
        .get(`informe-auditoria/partidos?torneo=${this.torneo}&fecha=${this.fecha}&fromConsultas=true&club=${this.club}`)
        .then(response => {
          this.partidos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchInformes () {
      let partido = this.partidos.filter(partido => partido.id === this.partido)
      if (partido) {
        this.stadium = partido[0].stadiumName
        this.dayhour = partido[0].dateRealization
      }
      this.axios
        .get(`informe-auditoria/informes-aprobados?partido=${this.partido}`)
        .then(response => {
          this.informes = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchEstadios () {
      this.axios
        .get(`informe-auditoria/informes-aprobados?partido=${this.partido}`)
        .then(response => {
          this.informes = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchTiposExpedientes () {
      this.axios
        .get(`expedientes/tipos`)
        .then(response => {
          this.tipos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    cleanAll () {
      this.fecha = null
      this.partidos = []
      this.partido = null
      this.stadium = null
      this.dayhour = null
      this.informes = []
      this.informe = null
    },
    retornarAutorInforme () {
      this.informes.filter((informe) => {
        if (informe.pk === this.informe) {
          this.autorInforme = informe.author
        }
      })
    }
  },

  mounted () {
    this.fetchClubs()
    this.fetchTiposExpedientes()
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}

.title-form {
  font-size: 1.3em;
}

.square-button {
  margin: 0.5em 0 0 0;
  padding: 0 !important;
  width: 2em !important;
  height: 2em;
  min-width: 20px;
}

.autor-informe {
  align-self: center;
  font-size: 16px;
}
</style>
